// 本系统的接口文件，里另外两个是中水系统的
export let ips = {
    dev: "http://192.168.1.22",
    // prod: "http://210.73.207.8",
    prod: "http://140.210.143.5",
    // prod: 'http://192.168.2.7',
    wuhao: "http://i328855i12.qicp.vip:33103",
}
export let ports = {
    dev: {
        base: "7878/yzzy",
        img: "7878/yzzy"
    },
    // prod: {
    //     base: "8080/yzzy/",
    //     img: "8011/yzzy_res/"
    // },
    prod: {
        base: "8080/yzzy",
        // base: '7878/yzzy',
        basePort: "8080",
        img: "8011/yzzy_res/",
        // 原始的ais接口
        ais: "7001"
    }

}
export const aisToken = "gs2022devtoken"
export const baseIp = ips.prod
export const baseUrl = baseIp + ":" + ports.prod.base;
// export const baseUrl = "http://192.168.1.236:7878/yzzy/";
export const aisBaseUrl = baseIp + ":" + ports.prod.ais;
export const baseAddress = baseIp + ":" + ports.prod.basePort;
// export const baseUrl = `http://i328855i12.qicp.vip:33103/yzzy/`;

export const imgUrl = baseIp + ":" + ports.prod.img;

// export const newsUrl = "http://210.73.207.8:8080/yzzy_news/ListNews";
// export const reportUrl = "http://210.73.207.8:8080/yzzy/topic/getTopicReportList";
export const newsUrl = "http://140.210.143.5:8080/yzzy_news/ListNews";
export const reportUrl = "http://140.210.143.5:8080/yzzy/topic/getTopicReportList";

const urls = {
    getHisShipLocationInfo: baseUrl + "/ais_server/getHisShipLocationInfo", //历史轨迹
    getHisShipLocationInfoMulti: baseUrl + "/ais_server/getHisShipLocationInfoMulti",
    getRealShipByMmsi: baseUrl + "/ais_server/getRealShipByMmsi",
    getRealShipByMmsis: baseUrl + "/ais_server/getRealShipByMmsis",
    getRealShipLocationExtent: baseUrl + "/ais_server/getRealShipLocationExtent",
    getHisShipHistoryDump: baseUrl + "/ais_server/getHisShipHistoryDump", //历史快照
    createHisShipHistoryDumpTask: baseUrl + "/ais_server/createHisShipHistoryDumpTask", //历史快照——任务形式

    getAisHistorySnapshot: baseUrl + "/ais_server/getAisHistorySnapshot", //多边形查历史快照
    createAisHistorySnapshotTask: baseUrl + "/ais_server/createAisHistorySnapshotTask", //多边形查历史快照_任务形式
    getAisHistorySnapshotStatic: baseUrl + "/ais_server/getAisHistorySnapshotStatic", //多边形历史快照统计
    getHisShipHistoryDumpStatic: baseUrl + "/ais_server/getHisShipHistoryDumpStatic", //范围历史快照统计
    getDtypeList: baseUrl + "/ais_server/getDtypeList",
    getFishDtypeList: baseUrl + "/fish/getDtypeList",
    getFishYytypeList: baseUrl + "/ais_server/codelistbypid", // 获取渔业平台类型数据
    getAllFishInfo: baseUrl + "/fish/getAllFishInfo",
    getFishCatchAnnualTotal: baseUrl + "/catch/getFishCatchAnnualTotal", //鱼获总产量
    getFishCatchVariable: baseUrl + "/catch/getFishCatchVariable", //鱼获有无数据的月份
    getHistoryFishCatch: baseUrl + "/catch/getHistoryFishCatch", // 某年某月鱼获
    getShipDetailList: baseUrl + "/ais_server/getShipDetailList", //获取筛选渔船
    getShip: baseUrl + "/fish/getShipList", //查询渔船
    getAisExtentStatistics: baseUrl + "/ais_server/getAisExtentStatistics",
    getAisShipStatistics: baseUrl + "/ais_server/getAisShipStatistics", //get 矩形范围 
    getAisAnyShipStatistics: baseUrl + "/ais_server/getAisAnyShipStatistics", //，post 多边形范围
    setFishLocation: baseUrl + "/fish/setFishLocation",
    getAisShipList: baseUrl + "/ais_server/getAisShipList", //多边形范围查询
    download: baseUrl + "/aishistory/download", //通过参数下载
    downloadByFile: baseUrl + "/aishistory/downloadByFile", //通过参数下载
    getpercent: baseUrl + "/aishistory/getpercent", //获取下载百分比
    getdownloadrecordlist: baseUrl + "/aishistory/getdownloadrecordlist", //获取下载列表
    getTaskProgressById: baseUrl + "/aishistory/getTaskProgressById", //根据id获取下载进度
    deletedownloadrecord: baseUrl + "/aishistory/deletedownloadrecord", // 删除下载记录
    killThreadByName: baseUrl + "/ais_server/killThreadByName", //杀死后台任务线程
    killAisHistorySnapshotTask: baseUrl + "/ais_server/killAisHistorySnapshotTask", //杀死多边形
    killHisShipLocationTask: baseUrl + "/ais_server/killHisShipLocationTask", //杀死作业规律
    killHisShipHistoryDumpTask: baseUrl + "/ais_server/killHisShipHistoryDumpTask", //杀死历史快照
    createHisShipLocationTask: baseUrl + "/ais_server/createHisShipLocationTask", //创建历史轨迹查询任务
    getHisShipLocationInfoMultiByTask: baseUrl + "/ais_server/getHisShipLocationInfoMultiByTask", //通过任务id 查询历史轨迹
    // login: "http://210.73.207.8:8080/dtadmin/api/login",
    // loginNew: "http://210.73.207.8:8080/dtadmin/api/loginWithJudge",
    // logout: "http://210.73.207.8:8080/dtadmin/api/logout",
    login: "http://140.210.143.5:8080/dtadmin/api/login",
    loginNew: "http://140.210.143.5:8080/dtadmin/api/loginWithJudge",
    loginWx: "http://140.210.143.5:8080/dtadmin/api/wx/login",
    logout: "http://140.210.143.5:8080/dtadmin/api/logout",
    getAisShipByBlurryMsg: baseUrl + "/ais_server/getAisShipByBlurryMsg", //根据输入对船进行模糊查询
    // 改用渔业系统的接口
    getAisShipByBlurryMsgFisher: baseUrl + "/onboard/map/search/vague",
    getFishOrganizeList: baseUrl + "/fish/getFishOrganizeList",
    getShipByAnyExtent: aisBaseUrl + "/dt/ais/v1/real/extent/any",
    // 休渔区历史统计
    getxyqCount: baseUrl + "/ais_server/getxyqCount",
    getBehavior: baseUrl + "/fishery_work/get_behavior",
    getFilterList: baseUrl + "/fishing_area/getFilterList",

    getFishCatchTimes: baseUrl + "/fishing_area/getFishCatchTimes",
    getFishCatchSpaces: baseUrl + "/fishing_area/getFishCatchSpaces",
    submitUserFeedback: baseUrl + "/feedback/add",
    // getAvailableMonthByYear: baseUrl + "/fishing_area/getMonthByYear",getMonth
    getAvailableMonthByYear: baseUrl + "/fishing_area/getMonth",
    getEezIn: baseUrl + "/ais_server/getEezIn",
    getFaoYearData: baseUrl + "/fishing_area/getFaoYearData",
    getFaoFishData: baseUrl + "/fishing_area/getFaoFishData",
    getRfmoYearData: baseUrl + "/fishing_area/getRfmoYearData",
    getRfmoFishData: baseUrl + "/fishing_area/getRfmoFishData",
    downloadFao: baseUrl + "/fishing_area/downloadFao",
    downloadRFMO: baseUrl + "/fishing_area/downloadRfmo",
    downloadCompareData: baseUrl + "/fishing_area/fishCatchDimensionComparisonDownload",
    getRfmoMaxYear: baseUrl + "/fishing_area/getRfmoMaxYear",
    getFaoUnitType: baseUrl + "/fishing_area/getFaoCatchType",
    getMeetingInfos: baseUrl + '/meeting/getMeetingInfos',
    getRfmoFishCodeList: baseUrl + '/fishing_area/getLinkedDataByType',
    getRfmoFaoInputData: baseUrl + "/fishing_area/getFishCatchNew",
    getFaoFishDataInputPie: baseUrl + "/fishing_area/getFishCatchPieNew",
    getRfmoFaoInputDataV2: baseUrl + "/fishing_area/getFishCatchNewV2",
    getFaoFishDataInputPieV2: baseUrl + "/fishing_area/getFishCatchPieNewV2",
    getCompareData: baseUrl + "/fishing_area/fishCatchDimensionComparison",
    setUserInfoUrl: "http://140.210.143.5:8080/dtadmin/userinfo/setWxUserType", //设置人员信息
    getRfmoFileAreaList: baseUrl + "/rfmoFile/getRfmoList",
    getConservationFiles: baseUrl + "/rfmoFile/getRfmoFileList",
}
import { fetchGet, fetchPost, postFile, postForm } from "../config/axiosConfig";
import coordUtils from "@/utils/coordinate"
import { sliceArray } from "@/pages/tablePanels/ship/shipMethods/shipLayer"
import axios from "axios";


/**
 *当接口data返回数组时，合并所有请求
 * @param {*} promises 
 */
export function mergeAllPromiseArray(promises) {
    return new Promise(resolve => {
        Promise.all(promises).then(res => {
            let data = []
            if (res.length > 0) {
                result = res[0]
                // 将所有结果加入数组
                res.forEach(({ data: dt }) => {
                    if (dt.length > 0) {
                        if (Array.isArray(dt)) {

                            data = data.concat(dt)
                        }
                    }
                })
            }
            resolve(data, res)
        })
    })
}
/**
 * 任何一个请求完成都会触发回调
 * @param {*} promises 
 */
export function everyPromise(promises, each, onEnd) {
    let len = promises.length
    return new Promise((resolve, reject) => {

        promises.forEach(pro => {
            pro.then(each).catch(reject).finally(() => {
                len--
                if (len == 0) {
                    if (onEnd) {
                        onEnd()
                    }
                }
            })
        })
    })



}
/**
 * 
 * @param {*} data mmsis st ed
 */
export function getHisShipLocationInfo(data) {
    let url = urls.getHisShipLocationInfo
    return fetchGet(url, data)
}
/**
 * 获取多条船的历史轨迹
 * @param {*} data 
 * @returns 
 */
export function getHisShipLocationInfoMulti(data) {
    let url = urls.getHisShipLocationInfoMulti
    return fetchGet(url, data)
}

// 现在可以传入limit 所以不用slice 了
export function getHisShipLocationInfoMultiEvery(data, eachFunc, endFunc) {
    let { mmsis, st, et, limit } = data
    // return getHisShipLocationInfoMulti({
    //         mmsis: mmsis.join(","),
    //         st,
    //         et,
    //         limit: mmsis.length + 10
    //     })
    let promises = sliceArray(mmsis, 400).map(v => {
        return getHisShipLocationInfoMulti({ mmsis: v.join(","), st, et, limit })
    })
    return everyPromise(promises, eachFunc, endFunc)

}

/**
 * h获取多条船的历史轨迹，自动切割
 * @param {*} data 
 * @returns 
 */
export function getHisShipLocationInfoMultiAuto(data) {
    let { mmsis, st, et } = data
    let promises = sliceArray(mmsis, 39).map(v => {
        return getHisShipLocationInfoMulti({ mmsis: v.join(","), st, et })
    })
    return new Promise((resolve, reject) => {

        Promise.all(promises).then(res => {
            let data = []
            let result = { code: 0, msg: "suc", data: [] }
            if (res.length > 0) {
                result = res[0]
                // 将所有结果加入数组
                res.forEach(({ data: dt }) => {
                    if (Array.isArray(dt)) {
                        data = data.concat(dt)
                    }
                })
            }
            result.data = data
            resolve(result)
        })
    })
}

// 在接口上进行火星坐标转换
/**
 * 
 * @param {*} data mmsi
 * @returns 
 */
export function getRealShipByMmsi(data) {
    let url = urls.getRealShipByMmsi
    return fetchGet(url, data, false).then((res) => {
        let { data } = res
        if (data) {
            [data.gc_lng, data.gc_lat] = coordUtils.wgs84_to_gcj02(data.lng, data.lat)
        }
        return { ...res, data }
    })
}
/**
 * 查询多边形范围内的渔船
 * @param {Array<Array<number>>} coords 
 */
export function getAisShipList(coords, country, inner,inner2) {

    let geoJson = {
        geo: coords,
        inner: inner? inner : null,
        inner2
    }
    let url = urls.getAisShipList + "?limit=10000"
    return fetchPost(url, geoJson, country ? {
        params: {
            country
        }
    } : {});

}
/**
 * 
 * @param {*} data mmsi
 * @returns 
 */
export function getRealShipByMmsis(data) {
    let url = urls.getRealShipByMmsis
    return fetchGet(url, data, false).then((res) => {
        let { data } = res
        if (Array.isArray(data) && data.length > 0) {
            data.forEach(ship => {
                if (!ship || !ship.mmsi) return;
                [ship.gc_lng, ship.gc_lat] = coordUtils.wgs84_to_gcj02(ship.lng, ship.lat)
            })
        }
        return { ...res, data }
    })
}
/**
 * 自动切割
 * @param {} data 
 * @para
 * @returns 
 */
export async function getShipByMMsisAuto(mmsiArray) {
    let mmsis = Array.from(new Set(mmsiArray));
    if (mmsis.length == 0) return new Promise(resolve => {
        resolve({ code: 0, data: [], msg: "suc" })
    })
    let promises = sliceArray(mmsis, 1000).map(mmsi => {

        return getRealShipByMmsis({ mmsis: mmsi.join(","), limit: 1000 })
    })
    try {

        let res = await Promise.all(promises)
        let resArr = []

        res.forEach(({ data }) => {
            if (Array.isArray(data)) {

                resArr = resArr.concat(data)
            }
        })
        return { code: 0, data: resArr, msg: "suc" }
    } catch (e) {
        return { data: null, code: -1, msg: "fail" }
    }

}
/**
 * 
 * @param {*} data slon slat elon elat
 * @returns 
 */
export function getRealShipLocationExtent(data) {
    let url = urls.getRealShipLocationExtent
    // 每次查询条数限制
    if (!data.limit) {

        data.limit = 3000
    }
    return fetchGet(url, data, false)
}
/**
 * 根据范围直接查询到最终数据
 * @param {*} params slon slat elon elat
 */
export async function getShipsByExtent(params) {
    return await getRealShipLocationExtent(params)
    // if (Array.isArray(data) && data.length > 0) {
    //     // 去重
    //     let mmsis = Array.from(new Set(data.map(v => v.mmsi)));
    //     let promises = sliceArray(mmsis, 39).map(mmsi => {
    //         return getRealShipByMmsis({ mmsis: mmsi.join(",") })
    //     })
    //     try {

    //         let res = await Promise.all(promises)
    //         let resArr = []
    //         res.forEach(({ data }) => {
    //             if (Array.isArray(data)) {

    //                 resArr = resArr.concat(data)
    //             }
    //         })
    //         return { code: 0, data: resArr, msg: "suc" }
    //     } catch (e) {
    //         return { data: null, code: -1, msg: "fail" }
    //     }


    // }
    // return { data, code, msg }
}

/**
 * 查询历史快照
 */
export async function getHisShipHistoryDump(data) {
    let url = urls.getHisShipHistoryDump
    // 每次查询条数限制
    if (!data.limit) {

        data.limit = 500
    }
    return fetchGet(url, data, false)

}
/**
 * 创建查询历史快照任务
 * @param {*} param 
 */
export function createHisShipHistoryDumpTask(data) {
    let url = urls.createHisShipHistoryDumpTask
    // if (!data.limit) {

    //     data.limit = 500
    // }
    return fetchGet(url, data, false)
}
/**
 * 创建杀死查询历史快照任务
 * @param {*} param 
 */
export function killHisShipHistoryDumpTask(data) {
    let url = urls.killHisShipHistoryDumpTask
    return fetchGet(url, data, false)
}

/**
 * 多边形历史快照
 * @param {*} param0 
 * @returns 
 */
export function getAisHistorySnapshot({ geo, time, limit }) {
    let url = urls.getAisHistorySnapshot
    return fetchPost(url, { geo }, { params: { time, limit } })
}

/**
 * 多边形历史统计
 * @param {*} param0 
 * @returns 
 */
export function getAisHistorySnapshotStatic({ geo, time }) {
    let url = urls.getAisHistorySnapshotStatic
    return fetchPost(url, { geo }, { params: { time } })
}
/**
 * 多边形历史统计_任务形式
 * @param {*} param0 
 * @returns 
 */
export function createAisHistorySnapshotTask({ geo, time }) {
    let url = urls.createAisHistorySnapshotTask
    return fetchPost(url, { geo }, { params: { time } })
}
/**
 * 杀死多边形历史统计_任务形式
 * @param {*} param0 
 * @returns 
 */
export function killAisHistorySnapshotTask({ geo, time, threadName }) {
    let url = urls.killAisHistorySnapshotTask
    return fetchPost(url, { geo }, { params: { time, threadName } })
}

/**
 * 历史快照范围查询
 * @param {*} data 
 * @returns 
 */
export function getHisShipHistoryDumpStatic(data) {
    let url = urls.getHisShipHistoryDumpStatic
    return fetchGet(url, data)
}

/**
 * 获取下拉选项
 * @param {"country"|"company"|"ship"} dtype 
 * @returns 
 */
export async function getDtypeList({ dtype, variable }) {
    let url = urls.getDtypeList
    return fetchGet(url, { dtype, variable }, false)
}
export function getFishDtypeList({ dtype, variable }) {
    let url = urls.getFishDtypeList
    return fetchGet(url, { dtype, variable }, false)
}

export function getFishYytypeList() {
    let url = urls.getFishYytypeList + `?p=2005`
    return fetchGet(url)
}

/**
 * 获取所有的鱼种信息撒点
 */
export function getAllFishInfo() {
    let url = urls.getAllFishInfo
    return fetchGet(url)
}
/**
 * 
 * @param {*} param  company country type
 * @returns 
 */
export function getShipDetailList(param) {
    let url = urls.getShipDetailList
    return fetchGet(url, param)
}
/**
 * 获取渔区列表
 * @returns 
 */
export function getFishOrganizeList() {
    let url = urls.getFishOrganizeList
    return fetchGet(url, {}, false)
}
/**
 * 搜索渔船
 * @param {*} param 
 * @returns 
 */
export function getShip(param) {
    let url = urls.getShip
    if (typeof param.flag == "undefined") {
        param.flag = 1
    }
    return postForm(url, param)
}

export function getNewsList(param) {
    return fetchGet(newsUrl, param)
}

export function getMeetingInfos() {
    return fetchGet(urls.getMeetingInfos)
}


export function getFishCatchAnnualTotal(param) {
    let url = urls.getFishCatchAnnualTotal
    return fetchGet(url, param)
}

export function getFishCatchVariable(param) {
    let url = urls.getFishCatchVariable
    return fetchGet(url, param)
}

export function getHistoryFishCatch(param) {
    let url = urls.getHistoryFishCatch
    return fetchGet(url, param)
}
export function setFishLocation(list) {
    let url = urls.setFishLocation
    return fetchPost(url, list)
}
//获取首页-专题报告列表
export function getTopicReportList(year) {
    return fetchGet(reportUrl, { year })
}
//获取首页-全球渔船chart
export function getGlobalShipData() {
    return fetchGet(baseUrl + '/fish/getShipTypeRatio')
}
//获取首页-鱼种产量排名
export function getFishYieldRanking(year) {
    return fetchGet(baseUrl + '/fishing_area/getFishYieldRanking', { year })
}
//获取首页-鱼种产量趋势
export function getFishYieldTrend(fishCode) {
    return fetchGet(baseUrl + '/fishing_area/getFishYieldTrend', { fishCode })
}
//获取首页-鱼种产量趋势-鱼种列表
export function getFishYieldTrend_FishCode() {
    return fetchGet(baseUrl + '/fishing_area/getFishCode')
}
//获取首页-FAO区域产量趋势
export function getFaoYieldTrend(fao) {
    return fetchGet(baseUrl + '/fishing_area/getFaoYieldTrend', { fao })
}
//获取首页-RFMO区域产量趋势
export function getRfmoYieldTrend(rfmo) {
    return fetchGet(baseUrl + '/fishing_area/getRfmoYieldTrend', { rfmo })
}
//获取资源评估-渔获数据
export function getSaCatchDataList(fishId) {
    return fetchGet(baseUrl + '/sa/getSaCatchDataList', { fishId })
}
//获取资源评估-数据分类
export function getSaClassification(fishId) {
    return fetchGet(baseUrl + '/sa/getSaClassification', { fishId })
}

//获取渔业产量-资源评估
export function getSaFishYield(fishId) {
    return fetchGet(baseUrl + '/sa/getSaEvaluationInfo', { fishId })
}


//获取资源评估-调查数据
export function getSaSurveyDataList(fishId) {
    return fetchGet(baseUrl + '/sa/getSaSurveyDataList', { fishId })
}
//下载资源评估-文件
export function getSaFile(fileType, fishId) {
    return fetchGet(baseUrl + '/sa/getSaFile', { fishId, fileType })
}
// 获取资源评估-图片
export function getSaClassificationImage(fishId) {
    return fetchGet(baseUrl + '/sa/getSaClassificationImage', { fishId })
}

//查询统计--区域
export function getAisExtentStatistics(params, country) {
    let url = urls.getAisExtentStatistics;
    return fetchGet(url, params, country ? {
        country
    } : {})
}

/**
 * 对船进行模糊搜索
 * @param {*} param0 
 * @returns 
 */
export function getAisShipByBlurryMsg({ msg, limit }) {
    let url = urls.getAisShipByBlurryMsg
    limit = limit || 10
    return fetchGet(url, { msg, limit }, false)
}
export function getAisShipByBlurryMsgFisher({ msg, limit }) {
    let url = urls.getAisShipByBlurryMsgFisher
    limit = limit || 10
    return fetchGet(url, { v: msg }, false)
}
/**
/**
 * 查询统计--多边形
 */
export function getAisExtentStatisticsPoly(coords, country, inner,inner2) {
    let url = urls.getAisAnyShipStatistics
    let json = {
        geo: coords,
        inner,
        inner2: inner2 && Array.isArray(inner2) && inner2.length!=0 ? inner2 : null
    }
    return fetchPost(url, json, {
        params: {
            country
        }
    })
}
//查询统计--渔船
export function getAisShipStatistics(params) {
    let url = urls.getAisShipStatistics;
    return postForm(url, params)
}
/**
 * @param {{year,month,countrys,downloaduserid,downloadtype}} data
 * @returns 
 */
export function download(data) {
    let url = urls.download
    return fetchPost(url, null, { params: data })
}
export function downloadByFileApi(data) {
    let url = urls.downloadByFile
    return postForm(url, data)

}
export function getDownloadPath(path) {
    // return baseAddress + path
    return ips.prod + ":8011/res/" + path
    // return "/yzzy_res/FileBufferPath/20220627-1724-5075-2000-23CBAC21A871.zip"
}
/**
 * 获取下载列表
 * @param {*} data 
 * @returns 
 */
export function getdownloadrecordlist(data) {
    let url = urls.getdownloadrecordlist
    return fetchGet(url, data, false)
}

/**
 * 
 * @param {*} data 
 */
export function deletedownloadrecord(data) {
    let url = urls.deletedownloadrecord
    return fetchGet(url, data)
}
/**
 * 以任务的形式查询历史轨迹
 */
export function createHisShipLocationTask(data) {
    let url = urls.createHisShipLocationTask
    return fetchPost(url, data)
}

/**
 *杀死以任务的形式查询历史轨迹
 */
export function killHisShipLocationTask(data) {
    let url = urls.killHisShipLocationTask
    return fetchPost(url, data)
}
/**
 * 通过线程名杀死后台线程
 * @param {*} param0 
 * @returns 
 */
export function killThreadByName(threadName) {
    let url = urls.killThreadByName
    return fetchGet(url, { threadName }, false)
}
/**
 * 
 * @param {{id:string}} data 
 * @returns 
 */
export function getTaskProgressById(data) {
    let url = urls.getTaskProgressById
    return fetchGet(url, data, false)
}

/**
 * 
 * @param {{taskId:string,percent:number}} data 
 */
export function getHisShipLocationInfoMultiByTask(data) {
    let url = urls.getHisShipLocationInfoMultiByTask
    return fetchGet(url, data, false)
}
/**
 * 登录
 * @param {*} data 
 * @returns 
 */
export function login(data) {
    // let url = urls.login
    let url = urls.loginNew
    return postForm(url, data)
}

/**
 * 微信登录
 * @param {*} data 
 * @returns 
 */
export function loginWx(data) {
    let url = urls.loginWx
    let formData = new FormData()
    formData.append("code", data.code)
    return fetchPost(url,formData)
}



/**
 * 登出
 */
export function logout() {
    let url = urls.logout
    return fetchPost(url)
}
/**
 * 根据范围和船旗查询渔船
 * @param {*} country 国家中文名
 * @param {*} geo 范围
 */
export function getShipByAnyExtent(country, geo) {
    let url = urls.getShipByAnyExtent;
    return fetchPost(url, { geo }, {
        params: { token: aisToken, limit: 1000, shipType: 30, country },
        headers: {
            "Content-Type": "application/json"
        }
    })

}

export function getXyqCount({ st, et }, geo) {
    let url = urls.getxyqCount;
    return fetchPost(url, { geo }, {
        params: { st, et },
        headers: {
            "Content-Type": "application/json"
        }
    }, true)
}

export function getBehavior(mmsi, dateTime) {
    let url = urls.getBehavior;
    return fetchGet(url, { mmsi, dateTime })
}

export function getFilterList({ dataSource, region, sTime, eTime }) {
    let url = urls.getFilterList
    return fetchGet(url, {
        dataSource, region, sTime, eTime
    })
}

/**
 * 
 * @param {{region, sTime, eTime, fishCode, country, gearCode}} data 
 * @returns 
 */
export function getFishCatchTimes(data) {
    let url = urls.getFishCatchTimes;
    return postForm(url, data);
}
/**
 * 
 * @param {{region, sTime, eTime, fishCode, country, gearCode, totalType}} data 
 * @returns 
 */
export function getFishCatchSpaces(data) {
    let url = urls.getFishCatchSpaces;


    return postForm(url, data);
}

export function getAvailableMonthByYear(params) {
    let url = urls.getAvailableMonthByYear;
    return fetchGet(url, params);
}

/**
 * 越界统计
 */
export function getEezIn() {
    return fetchGet(urls.getEezIn)
}

/**
 * 获取FAO年度数据
 * @param {{fao:string,totalType:string}} params 
 * @returns 
 */
export function getFaoYearData(params) {
    return fetchGet(urls.getFaoYearData, params)
}

/**
 * 
 * @param {{fao:string,year:string}} params 
 * @returns 
 */
export function getFaoFishData(params) {
    return fetchGet(urls.getFaoFishData, params);
}

/**
 * 获取RFMO年度数据
 * @param {{rfmo:string}} params 
 * @returns 
 */
export function getRFMOYearData(params) {
    return fetchGet(urls.getRfmoYearData, params)
}

/**
 * 
 * @param {{RFMO:string,year:string}} params 
 * @returns 
 */
export function getRFMOFishData(params) {
    return fetchGet(urls.getRfmoFishData, params);
}

/**
 * 获取FAO输入数据
 * @param {{fao:string,year:string}} params 
 * @returns 
 */
export function getFaoFishDataInputPie(params) {
    return fetchGet(urls.getFaoFishDataInputPie, params);
}

/**
 * 获取FAO输入数据
 * @param {{fao:string,year:string}} params 
 * @returns 
 */
export function getFaoFishDataInputPieV2(params) {
    return fetchGet(urls.getFaoFishDataInputPieV2, params);
}

/**
 * 获取比较数据
 * @param {*} params 
 * @returns 
 */
export function getCompareData(params) {
    return fetchPost(urls.getCompareData, params);
}
/**
 * 下载FAO数据
 * @param {*} params 
 * @returns 
 */
export function downloadFao({ fao, name, documentType }) {
    return axios.get(urls.downloadFao, {
        params: { fao, documentType },
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        // document.body.appendChild(link);
        link.click();
    });

}
/**
 * 下载FAO数据input
 * @param {*} params 
 * @returns 
 */
export function downloadFaoNew({ country,fishCode, name, documentType,fao,startYear,endYear }) {
    return axios.get(urls.downloadFao, {
        params: { country,fishCode, documentType,fao,startYear,endYear },
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        // document.body.appendChild(link);
        link.click();
    });

}
/**
 * 下载RFMO数据
 * @param {*} params 
 * @returns 
 */
export function downloadRFMO({ rfmo, name, documentType }) {
    // return fetchGet(urls.downloadRFMO, params)
    return axios.get(urls.downloadRFMO, {
        params: { rfmo, documentType },
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        // document.body.appendChild(link);
        link.click();
    });
}

export function downloadRFMONew({ rfmo, name, documentType,country,fishCode,startYear,endYear }) {
    // return fetchGet(urls.downloadRFMO, params)
    return axios.get(urls.downloadRFMO, {
        params: { rfmo, documentType,country,fishCode,startYear,endYear },
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        // document.body.appendChild(link);
        link.click();
    });
}

/**
 * 获取rfmo 有数据的最新年份
 * @param {*} rfmo 
 * @returns 
 */
export function getRfmoMaxYear(rfmo) {
    return fetchGet(urls.getRfmoMaxYear, { rfmo })
}


/**
 * 获取指定FAO区域的可用单位（重量？数量？）
 * @param {*} fao FAO区域
 * @returns
 */
export function getFaoUnitType(fao) {
    return fetchGet(urls.getFaoUnitType, { fao })
}

/**
 * 获取指定FAO区域的可用单位（重量？数量？）
 * @param {*} fao FAO国家和鱼种查询
 * @returns
 */
export function getFaoUnitTypeByFishCode(country,fishCode) {
    return fetchGet(urls.getFaoUnitType, { country, fishCode})
}

/**
 * 获取全球渔业rfmo列表
 */
export function getRfmoFishCodeList(queryData){
    return fetchGet(urls.getRfmoFishCodeList, queryData)
}

/**
 * 获取RFMO与FAO输入数据
 * @param {{rfmo:string}} params 
 * @returns 
 */
export function getRfmoFaoInputData(params) {
    return fetchGet(urls.getRfmoFaoInputData, params)
}

/**
 * 获取RFMO与FAO输入数据V2
 * @param {{rfmo:string}} params 
 * @returns 
 */
export function getRfmoFaoInputDataV2(params) {
    return fetchGet(urls.getRfmoFaoInputDataV2, params)
}

/**
 * 验证海洋图层是否可用
 * @param {*} params 
 * @returns 
 */
export function checkOceanLayer(url) {
    return fetchGet(url,{},false)
}


/**
 * 设置人员信息
 * @param {*} data 
 * @returns 
 */
export function setUserInfo(data) {
    let url = urls.setUserInfoUrl;
    let formData = new FormData();
    formData.append("accountNo", data.accountNo);
    formData.append("wxUserType", data.wxUserType);
    return fetchPost(url, formData);
}

/**
 * 提交用户反馈
 * @param {*} data 
 * @returns 
 */
export function submitUserFeedback(data) {
    let url = urls.submitUserFeedback;
    let formData = new FormData();
    formData.append("userId", data.userId);
    formData.append("contact", data.contact);
    formData.append("content", data.content);
    data.files.forEach((item) => {
        formData.append(`files`, item); 
    });
    return fetchPost(url, formData);
}

/**
 * 下载比较数据
 * @param {*} data 
 * @returns 
 */
export function downloadCompareData(compareData) {
    let url = urls.downloadCompareData;
    return new Promise((resolve, reject) => {
        axios.post(url, compareData, {
            responseType: 'blob', // important
        })
        .then((res) => {
            resolve(res);
        })
        .catch((err) => {
            reject(err);
        });
    });
}


/**
 * 获取RFMO文件区域列表
 * @returns 
 */
export function getRfmoFileAreaList() {
    return fetchGet(urls.getRfmoFileAreaList)
}


/**
 * 获取养护管理措施文件列表
 * @param {String} fileType 文件类型
 * @param {String} region 地区
 * @returns 
 */
export function getConservationFiles(fileType, region) {
    return fetchGet(urls.getConservationFiles, { fileType: fileType, rfmo: region })
}



// WEBPACK FOOTER //
// ./src/service/apis.js